export default function initAccordions() {
	const $accordionTriggers = document.querySelectorAll(".accordion--toggle");

	$accordionTriggers.forEach($a => {
		$a.addEventListener("click", e => {
			$a.parentNode.classList.toggle("is-active");

			if ($a.dataset.linkedField) {
				document.querySelector(
					`#${$a.dataset.linkedField}`
				).dataset.selectable = true;
			}

			e.preventDefault();
		});
	});
}
